import React, { useEffect, useState } from "react"
import "./ViewInstitution.scss"
import { InputText } from "primereact/inputtext"
import { Button, Card, CardBody, Col, Row } from "reactstrap"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import InstituteApi from "Api/InstituteApi"

const ViewInstitution = () => {
  document.title = "View Institution"

  const navigate = useNavigate("")
  const location = useLocation()
  const accessToken = localStorage.getItem("accessToken")

  const [institutionData, setInstitutionData] = useState({})
  const { institutionCode } = useParams()

  const getCourse = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    InstituteApi.getInstitutionsById(institutionCode, config)
      .then(res => {
        setInstitutionData(res.data.institution)
      })
      .catch(err => {
        console.log(err)
      })
  }

  useEffect(() => {
    if (institutionCode) {
      getCourse()
    }
  }, [institutionCode])

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Institution", link: "#" },
    { label: "Institution Details", link: "#" },
  ]
  return (
    <div className="view-institution">
      <Row>
        <Col xs="12">
          <div className="institution-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb
              data={breadcrumbItems}
              pageTitle="Institution Details"
            />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="institution-view-form ">
                <div className="institution-view-inp">
                  <label htmlFor="institutionName" className="label">
                    Institution Name
                  </label>
                  <InputText
                    id="institutionName"
                    value={institutionData.institutionName}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="institution-view-inp">
                  <label htmlFor="university" className="label">
                    University
                  </label>
                  <span
                    className="institution-view-inp-span"
                    onClick={() => {
                      navigate(
                        `/view-university/${institutionData?.university?.universityCode}`,
                      )
                    }}
                  >
                    {institutionData?.university?.universityName}
                  </span>
                </div>
                <div className="institution-view-inp">
                  <label htmlFor="displayName" className="label">
                    Display Name
                  </label>
                  <InputText
                    id="displayName"
                    value={institutionData.displayName}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="institution-view-inp">
                  <label htmlFor="type" className="label">
                    Type
                  </label>

                  <InputText
                    id="type"
                    value={institutionData.type}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="institution-view-inp">
                  <label htmlFor="yearEstablished" className="label">
                    Year Established
                  </label>
                  <InputText
                    id="yearEstablished"
                    value={institutionData.yearEstablished}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="institution-view-inp">
                  <label htmlFor="country" className="label">
                    Country
                  </label>
                  <InputText
                    id="country"
                    value={institutionData.country}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="institution-view-inp">
                  <label htmlFor="state" className="label">
                    State
                  </label>

                  <InputText
                    id="state"
                    value={institutionData.state}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="institution-view-inp">
                  <label htmlFor="username" className="label">
                    City
                  </label>
                  <InputText
                    id="city"
                    value={institutionData.city}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="institution-view-inp">
                  <label htmlFor="pinCode" className="label">
                    PinCode
                  </label>
                  <InputText
                    id="pinCode"
                    value={institutionData.pinCode}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="institution-view-inp">
                  <label htmlFor="address" className="label">
                    Address
                  </label>
                  <InputText
                    id="address"
                    value={institutionData.address}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="institution-view-inp">
                  <label htmlFor="email" className="label">
                    Email
                  </label>
                  <InputText
                    id="email"
                    value={institutionData.email}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="institution-view-inp">
                  <label htmlFor="officialWebsite" className="label">
                    Official Website
                  </label>
                  <InputText
                    id="officialWebsite"
                    value={institutionData.officialWebsite}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="institution-view-inp">
                  <label htmlFor="campusSize" className="label">
                    campus Size
                  </label>
                  <InputText
                    id="campusSize"
                    value={institutionData.campusSize}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="institution-view-inp">
                  <label htmlFor="noOfStudents" className="label">
                    No Of Students
                  </label>
                  <InputText
                    id="noOfStudents"
                    value={institutionData.noOfStudents}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="institution-view-inp">
                  <label htmlFor="noOfDepartments" className="label">
                    No Of Departments
                  </label>
                  <InputText
                    id="noOfDepartments"
                    value={institutionData.noOfDepartments}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="institution-view-inp">
                  <label htmlFor="noOfCourses" className="label">
                    No Of Courses
                  </label>
                  <InputText
                    id="noOfCourses"
                    value={institutionData.noOfCourses}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="institution-view-inp">
                  <label htmlFor="totalFaculty" className="label">
                    Total Faculty
                  </label>
                  <InputText
                    id="totalFaculty"
                    value={institutionData.totalFaculty}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="institution-view-inp">
                  <label htmlFor="nirfRanking" className="label">
                    NIRF Ranking
                  </label>
                  <InputText
                    id="nirfRanking"
                    value={institutionData.nirfRanking}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="institution-view-inp">
                  <label htmlFor="indiaToday2023Ranking" className="label">
                    India Today 2023 Ranking
                  </label>
                  <InputText
                    id="indiaToday2023Ranking"
                    value={institutionData.indiaToday2023Ranking}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="institution-view-inp">
                  <label htmlFor="timesRanking2024" className="label">
                    Times Ranking 2024
                  </label>
                  <InputText
                    id="timesRanking2024"
                    value={institutionData.timesRanking2024}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="institution-view-inp">
                  <label htmlFor="ugcApproval" className="label">
                    UGC Approval
                  </label>
                  <InputText
                    id="ugcApproval"
                    value={institutionData.ugcApproval ? "Yes" : "No"}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="institution-view-inp">
                  <label htmlFor="aiuAffiliation" className="label">
                    AIU Affiliation
                  </label>
                  <InputText
                    id="aiuAffiliation"
                    value={institutionData.aiuAffiliation ? "Yes" : "No"}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="institution-view-inp">
                  <label htmlFor="highlights" className="label">
                    Highlights
                  </label>
                  <InputText
                    id="highlights"
                    value={institutionData.highlights}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="institution-view-inp">
                  <label htmlFor="aboutContent" className="label">
                    AboutContent
                  </label>
                  <InputText
                    id="aboutContent"
                    value={institutionData.aboutContent}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="institution-view-inp">
                  <label htmlFor="verifiedStatus" className="label">
                    Verified Status
                  </label>
                  <InputText
                    id="verifiedStatus"
                    value={
                      institutionData.verifiedStatus === "approve"
                        ? "Yes"
                        : "No"
                          ? "Yes"
                          : "No"
                    }
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="institution-view-inp">
                  <label htmlFor="verifiedReason" className="label">
                    Verified Reason
                  </label>
                  <InputText
                    id="verifiedReason"
                    value={
                      institutionData.verifiedReason
                        ? institutionData.verifiedReason
                        : "-"
                    }
                    className="inp-field-box"
                    disabled
                  />
                </div>
              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-start gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Back
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default ViewInstitution
